<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>

    @if (flyingGateways.length > 0) {
      <div class="title">{{ 'GATEWAY.FLYING' | translate | uppercase }}</div>
    }

    <div class="gateways">
      @for (gateway of flyingGateways; track gateway) {
        <div class="gateway">
          <div class="logo">
            <img [src]="gateway.isFlying ? 'assets/images/flying-gateway.png' : 'assets/images/gateway.jpeg'"/>
            <a>{{ gateway.gatewayId }}</a>
          </div>
          <div class="info">
            <a>{{ 'GATEWAY.NAME' | translate }}: {{ gateway.gatewayName }}</a>
            <a>{{ 'GATEWAY.MODEL' | translate }}: {{ gateway.gatewaymodelname }}</a>
          </div>
          <div class="add" (click)="addGateway(gateway)">
            <img src="assets/images/add-shopping-cart.svg"/>
          </div>
        </div>
      }
    </div>

    @if (missionSkidsGateways.length > 0) {
      <div class="title">{{ 'GATEWAY.SKID' | translate | uppercase }}</div>
    }

    <div class="gateways">
      @for (gateway of missionSkidsGateways; track gateway) {
        <div class="gateway">
          <div class="logo">
            <img [src]="gateway.isFlying ? 'assets/images/flying-gateway.png' : 'assets/images/gateway.jpeg'"/>
            <a>{{ gateway.gatewayId }}</a>
          </div>
          <div class="info">
            <a>{{ 'GATEWAY.NAME' | translate }}: {{ gateway.gatewayName }}</a>
            <a>{{ 'GATEWAY.MODEL' | translate }}: {{ gateway.gatewaymodelname }}</a>
          </div>
          <div class="add" (click)="addGateway(gateway)">
            <img src="assets/images/add-shopping-cart.svg"/>
          </div>
        </div>
      }
    </div>

    @if (missionAnalyzersGateways.length > 0) {
      <div class="title">{{ 'GATEWAY.ANALYZER' | translate | uppercase }}</div>
    }

    <div class="gateways">
      @for (gateway of missionAnalyzersGateways; track gateway) {
        <div class="gateway">
          <div class="logo">
            <img [src]="gateway.isFlying ? 'assets/images/flying-gateway.png' : 'assets/images/gateway.jpeg'"/>
            <a>{{ gateway.gatewayId }}</a>
          </div>
          <div class="info">
            <a>{{ 'GATEWAY.NAME' | translate }}: {{ gateway.gatewayName }}</a>
            <a>{{ 'GATEWAY.MODEL' | translate }}: {{ gateway.gatewaymodelname }}</a>
          </div>
          <div class="add" (click)="addGateway(gateway)">
            <img src="assets/images/add-shopping-cart.svg"/>
          </div>
        </div>
      }
    </div>

  </div>
</div>